import { Link, useParams, Navigate } from "react-router-dom";
import { SiteHeader, SiteFooter } from "@/components/SiteChrome";
import { Markdown } from "@/components/Markdown";
import { LEGAL } from "@/constants/legal";

export default function Legal() {
  const { slug } = useParams();
  const page = LEGAL[slug];
  if (!page) return <Navigate to="/legal/terms" replace />;
  return (
    <div className="min-h-screen">
      <SiteHeader links={false} />
      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-12 space-y-6">
        <nav className="flex flex-wrap gap-2 text-sm" aria-label="Legal pages">
          {Object.entries(LEGAL).map(([s, p]) => (
            <Link key={s} to={`/legal/${s}`} className={`px-3 py-1 rounded-full border ${s === slug ? "bg-teal-50 border-teal-300 text-teal-900" : "border-slate-200 text-slate-600 hover:border-teal-300"}`} data-testid={`legal-tab-${s}`}>{p.title}</Link>
          ))}
        </nav>
        <h1 className="text-4xl font-extrabold tracking-tight text-slate-900" data-testid="legal-title">{page.title}</h1>
        <Markdown>{page.body}</Markdown>
      </main>
      <SiteFooter />
    </div>
  );
}
